<template>
  <div>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-card
      max-width="960px"
      width="100%"
      height="100%"
      class="activity-page-height edit-mode mx-auto pa-16"
    >
      <v-row
        v-if="scormPackage == null && !loadingData"
        no-gutters
        class="v-bottom-navigation elevation-0 v-item-group bigButtonBackground align-center justify-center rounded-xxl"
        style="height:405px; min-width:220px"
      >
        <v-col
          cols="6"
          class="ma-15 hover custom-border "
          style="background-color: white"
          @click="showUploadScorm(true)"
        >
          <v-btn
            text
            data-testid="upload-button-center"
            :disabled="loadingUploadBigButton || loadingUpload"
            color="white"
            class="no-hover text-body-1 darktext--text text-none rounded-xxl px-4 mx-auto d-block my-10"
            :ripple="false"
          >
            <span class="grey--text">{{ loadingUploadBigButton ? $t('uploading') : $t('upload') }}</span>
            <v-icon
              v-if="!loadingUploadBigButton"
              size="72"
              color="grey"
            >
              mdi-upload
            </v-icon>
            <v-progress-circular
              v-if="loadingUploadBigButton"
              size="32"
              indeterminate
              class="mx-2 my-5 text-center justify-center"
            />
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="scormPackage != null && !loadingData">
        <v-col
          cols="12"
          class="scorm-player"
        >
          <iframe
            :src="scormPackage"
            style="border:none"
            data-testid="scorm-iframe"
          />
        </v-col>
      </v-row>
    </v-card>
    <v-navigation-drawer
      app
      permanent
      right
      clipped
      data-testid="navigation-drawer"
      width="300"
    >
      <template
        v-if="!loadingData"
        v-slot:prepend
      >
        <v-row>
          <v-col cols="5">   
            <v-menu
              ref="menuRef"
              offset-y
            >
              <!-- <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon data-testid="threedots-icon">
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <v-list data-testid="menu-list">
                <v-list-item data-testid="save-as-draft-item">
                  <v-list-item-title> {{ $t('saveAsDraft') }}</v-list-item-title>
                </v-list-item>
              </v-list> -->
            </v-menu>                    
          </v-col>
          <v-col
            cols="7"
            align="center"
          >                    
            <v-btn
              :disabled="loadingUpload || loadingUploadBigButton || !scormPackage"
              data-testid="submit-button-publish-changes"
              class="rounded-xxl text-none px-10 publish-scorm"
              :color="loadingUpload || loadingUploadBigButton || !scormPackage?'greytextlight':'success'"
              dark 
              @click="
                dialogPublishChangesVisible=true, 
                confirmationDialogTitle=$t('confirmationDialogTitleUpdateScorm'), 
                confirmationDialogText=$t('confirmationDialogTextUpdateScorm'), 
                confirmationDialogSubmitBtn=$t('confirmBtn')
                confirmationDialogCancelBtn=$t('cancel')"
            >
              {{ $t('publish') }}
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <v-divider />
      <v-tooltip
        v-if="!loadingData"
        left
        :disabled="! published"
      >
        <template v-slot:activator="{ on }">
          <v-card
            class="pa-2"
            elevation="0"
            v-on="on"
          >
            <v-btn
              data-testid="upload-button"
              :loading="loadingUpload"
              :disabled="loadingUpload || loadingUploadBigButton || published"
              color="white"
              width="100%"
              class="text-body-1 darktext--text text-none rounded-xxl my-10"
              @click="showUploadScorm(false)"
            >
              {{ $t('uploadNewScorm') }}
            </v-btn>
            <v-file-input
              ref="file_input"
              v-model="zipData"
              accept=".zip"
              data-testid="file-input"
              class="d-none"
              @change="uploadScorm"
            />
          </v-card>
        </template>
        <span>{{ $t('editPublishedScormTooltip') }}</span>
      </v-tooltip>
    </v-navigation-drawer>

    <ConfirmationDialog
      v-if="dialogPublishChangesVisible"
      ref="confirmationDialogPublishChanges"
      :visible="dialogPublishChangesVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      cd-submit-btn-color="accent"
      data-testid="confirmation-dialog-publish-changes"
      @close="dialogPublishChangesVisible=false"
      @proceedSubmit="saveScorm()"
    />
  </div>
</template>
<script>
import i18n from '../../plugins/i18n'
import ConfirmationDialog from '../../components/ConfirmationDialog';
import AlertMessages  from '../../components/AlertMessages'
import { getActivity, uploadScormPackage, getActivityScorm, updateActivityScorm } from '../../api/activityApi'

export default {
    components: {
        ConfirmationDialog,
        AlertMessages
    },
    data(){
         return{
            scormId: this.$route.params.scormId,
            activityId: this.$route.params.id,
            loadingData: false,
            alertMsg: '',
            alertType: '',
            alertValue:false,
            dialogPublishChangesVisible: false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            spaceId: window.$cookies.get('space_id'),
            published: false,
            valid: true,
            showImageRequiredError: false,
            loadingUpload: false,
            loadingUploadBigButton: false,
            zipData: null,
            scormPackage: null,
            dialogPublishVisible: false,
            uploadFromCenter: false,
            occupyInterval:null,
            role:''
       }
    },
     computed: {
        productPlan() {
        return this.$store.state.productPlan;
      }, 
    },
    mounted() {
      if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
        this.occupyEditor(); 
        this.occupyInterval = setInterval(() => {         
          this.occupyEditor(); 
        }, 60000)
      } 
    },
    async created(){
        this.loadingData = true
        await this.getActivity()
        if (this.role == 'participant' || this.role == 'guest') {
          this.$router.push({name: 'PageAccessDenied'})
        }
        await this.getScorm()
        this.loadingData = false

        //if someone else is editing
        if(this.$store.state.list.find(user => user.entity_id == this.scormId )){
            this.$router.push({name: 'ViewActivityScorm', params: {id: this.activityId, scormId: this.scormId, preventEditing: true}})
        }
    },  
    beforeDestroy() {
        clearInterval(this.occupyInterval)
    }, 
    methods:{
        occupyEditor(){
          var payload = {'key1': this.scormId, 'key2': this.activityId,'key3': 'scorm' }
              this.$store.dispatch("occupyEditor", payload).catch(() => {
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError') 
                    
                })
        },
        releaseEditor(){
          var payload = {'key1': this.scormId, 'key2': this.activityId,'key3': 'scorm' }
          this.$store.dispatch("releaseEditor", payload)
          .catch(() => {
              this.alertValue = true
              this.alertType = 'error'
              this.alertMsg =  i18n.t('serverError') 
            
        })
        },
        async getActivity(){
            try {
                const response = await getActivity(this.activityId)
                if(response.status == 200) {
                    this.role = response.data.data.attributes.role
                     }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        if(this.isAuth){
                            this.$router.push({name: 'PageNotFound'})
                        }else{
                            this.$router.push({name: 'CustomLogin', query: {referer: this.$route.fullPath}})
                        }
                    }else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    }else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async getScorm(){
            try {
                const response = await getActivityScorm(this.$route.params.scormId)
                if(response.status == 200) {
                    this.published = response.data.data.attributes.published
                    if(response.data.data.attributes.url != null){
                        this.scormPackage = process.env.VUE_APP_API_IFRAME_URL + '/activity/' + this.activityId + '/scorm/' + this.$route.params.scormId + '/' + window.$cookies.get("token");
                    }
                }  
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    }else {
                        this.alertValue = true
                        this.alertType = 'error';
                        this.alertMsg =  i18n.t('serverError');
                    }
                } 
            }
        },
        showUploadScorm(uploadFromCenter){
            if(!this.loadingUpload && !this.loadingUploadBigButton){
                this.$refs.file_input.$refs.input.click()
                this.uploadFromCenter = uploadFromCenter
            }
        },
        async uploadScorm(){
            if(this.zipData){
                if(this.zipData.size > 500*1024*1024){
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('uploadScormSizeError')
                    this.alertValue = true
                }else {
                    this.loadingUpload = !this.uploadFromCenter
                    this.loadingUploadBigButton = this.uploadFromCenter
                    try {
                        let data = new FormData();
                        data.append('file', this.zipData);
                        data.append('space_id', this.spaceId);
                       
                        const response = await uploadScormPackage(this.scormId, data) 
                        if(response.status == 200) {
                          if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
                           this.releaseEditor();
                          }
                          this.loadingUpload = false
                          this.alertMsg = ''
                          //added date parametar only to reload the iframe
                          this.scormPackage = process.env.VUE_APP_API_IFRAME_URL + '/activity/' + this.activityId + '/scorm/' + this.$route.params.scormId + '/' + window.$cookies.get("token") + '?' + Date.now();
                        }
                    } catch (e) {
                        if(e.response){
                            this.alertValue = true
                            if(e.response.status == 422){
                                for(let i = 0; i < e.response.data.errors.length; i++){
                                    if(e.response.data.errors[i].detail == 'Scorm version must be 1.2'){
                                        this.alertType = 'error'
                                        this.alertMsg = i18n.t('uploadScormVersionError')
                                    }else{
                                        this.alertType = 'error'
                                        this.alertMsg =  i18n.t('uploadScormError')
                                    }
                                }
                            } else if(e.response.status == 403){
                                for(let i = 0; i < e.response.data.errors.length; i++){
                                    if(e.response.data.errors[i].detail == 'Storage is full'){
                                        this.alertType = 'error'
                                        this.alertMsg =  i18n.t('storageFullError')
                                    }
                                    else {
                                        this.$router.push({name: 'PageAccessDenied'})
                                    }
                                }
                            }else {
                                this.alertType = 'error'
                                this.alertMsg =  i18n.t('serverError')
                            }
                        }
                    }
                    this.loadingUpload = false
                    this.loadingUploadBigButton = false
                }
            }
            this.$refs.file_input.$refs.input.value = ''
        },

        async saveScorm(){
            try {
                let data = {
                    data: {
                        type: "scorms",
                        id: this.scormId,
                        attributes: {
                            published: true
                        },
                        relationships: {
                            activity: {
                                data: {
                                    type: "activities",
                                    id: this.$route.params.id
                                }
                            }
                        }
                    }
                };
                const response = await updateActivityScorm(this.scormId, data)
                if (response.status == 200) {
                  if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
                   this.releaseEditor();
                  }
                  this.$router.push({name: 'ViewActivityScorm', params: {id: this.$route.params.id, scormId: this.scormId, successfullyUpdatedActivityScorm: true}})
                }
            } catch (e) {
                if(e.response){
                    if (e.response.status == 403){
                        for(let i = 0; i < e.response.data.errors.length; i++){
                            if(e.response.data.errors[i].detail == 'This action is unauthorized.'){
                                this.$router.push({name: 'PageAccessDenied'})
                            }
                            else {
                                this.alertValue = true
                                this.alertType = 'error'
                                this.alertMsg =  i18n.t('serverError')
                            }
                        }
                    } else{
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError') 
                    }           
                }
            }
            this.dialogPublishChangesVisible = false
        },
        clickOutside(){
            this.dialogPublishVisible=false
        }
    }
}
        
</script>
